import { all, put, select, takeLatest } from 'redux-saga/effects';

import {
  companyFailure,
  companyRequest,
  companySuccess,
  disableBranchesFailure,
  disableBranchesRequest,
  disableBranchesSuccess,
  disableSSOFailure,
  disableSSORequest,
  disableSSOSuccess,
  disableVisitorLogFailure,
  disableVisitorLogRequest,
  disableVisitorLogSuccess,
  enableBranchesFailure,
  enableBranchesRequest,
  enableBranchesSuccess,
  enableSSOFailure,
  enableSSORequest,
  enableSSOSuccess,
  enableVisitorLogFailure,
  enableVisitorLogRequest,
  enableVisitorLogSuccess,
  ssoConfigurationRequest,
  ssoConfigurationSuccess,
  updateSSOConfigurationFailure,
  updateSSOConfigurationRequest,
  updateSSOConfigurationSuccess,
} from './actions';
import axios from 'axios';
import { COMPANIES } from 'app/api-routes';

function* companySaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    const { payload } = yield axios.get(`${COMPANIES}/${companyInfo.companyID}`);

    yield put(companySuccess(payload));
  } catch (err) {
    yield put(companyFailure(err));
  }
}

function* enableVisitorLogSaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    yield axios.put(`${COMPANIES}/${companyInfo.companyID}/visitor-log/enable`);

    yield put(enableVisitorLogSuccess(companyInfo.companyID));
  } catch (err) {
    yield put(enableVisitorLogFailure(err));
  }
}

function* disableVisitorLogSaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    yield axios.put(`${COMPANIES}/${companyInfo.companyID}/visitor-log/disable`);

    yield put(disableVisitorLogSuccess(companyInfo.companyID));
  } catch (err) {
    yield put(disableVisitorLogFailure(err));
  }
}

function* enableSSOSaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    yield axios.put(`${COMPANIES}/${companyInfo.companyID}/sso/enable`);

    yield put(enableSSOSuccess(companyInfo.companyID));
  } catch (err) {
    yield put(enableSSOFailure(err));
  }
}

function* disableSSOSaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    yield axios.put(`${COMPANIES}/${companyInfo.companyID}/sso/disable`);

    yield put(disableSSOSuccess(companyInfo.companyID));
  } catch (err) {
    yield put(disableSSOFailure(err));
  }
}

function* updateSSOConfigurationSaga({ payload: { payload, callback } }) {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    yield axios.put(`${COMPANIES}/${companyInfo.companyID}/sso`, { payload });

    yield put(updateSSOConfigurationSuccess({ companyID: companyInfo.companyID, payload }));
  } catch (err) {
    yield put(updateSSOConfigurationFailure(err));
  } finally {
    callback?.();
  }
}

function* ssoConfigurationSaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    const { payload } = yield axios.get(`${COMPANIES}/${companyInfo.companyID}/sso`);

    yield put(ssoConfigurationSuccess({ companyID: companyInfo.companyID, payload }));
  } catch (err) {
    console.log('ERROR: ', err);
  }
}

function* enableBranchesSaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    yield axios.put(`${COMPANIES}/${companyInfo.companyID}/branches/enable`);

    yield put(enableBranchesSuccess(companyInfo.companyID));
  } catch (err) {
    yield put(enableBranchesFailure(err));
  }
}

function* disableBranchesSaga() {
  try {
    const { companyInfo } = yield select((state) => state.auth);

    yield axios.put(`${COMPANIES}/${companyInfo.companyID}/branches/disable`);

    yield put(disableBranchesSuccess(companyInfo.companyID));
  } catch (err) {
    yield put(disableBranchesFailure(err));
  }
}

export default function* () {
  yield all([
    yield takeLatest(companyRequest, companySaga),
    yield takeLatest(enableVisitorLogRequest, enableVisitorLogSaga),
    yield takeLatest(disableVisitorLogRequest, disableVisitorLogSaga),
    yield takeLatest(enableSSORequest, enableSSOSaga),
    yield takeLatest(disableSSORequest, disableSSOSaga),
    yield takeLatest(updateSSOConfigurationRequest, updateSSOConfigurationSaga),
    yield takeLatest(ssoConfigurationRequest, ssoConfigurationSaga),
    yield takeLatest(enableBranchesRequest, enableBranchesSaga),
    yield takeLatest(disableBranchesRequest, disableBranchesSaga),
  ]);
}
